import VAClient from './VAClient';

import VelasAccountProgram from './VelasAccountProgram';
import RelyingPartyProgram from './RelyingPartyProgram';

export default {
    VAClient: VAClient,
    VelasAccountProgram: VelasAccountProgram,
    RelyingPartyProgram: RelyingPartyProgram,
};